module.exports = __webpack_public_path__ + "assets/logoFunEatsNegro7d943b05.png";